import { ApiPoolInfoV4 } from '@raydium-io/raydium-sdk';
import axios from 'axios';

interface Session {
    id: string;
    mint: string;
    updatedAt: string;
}

interface ParsedTokenMetadata {
    name: string;
    symbol: string;
    description: string;
    image: string;
    telegram: string;
    twitter: string;
    website: string;
}

export class MintTsBackend {
    constructor(
        private readonly url: string,
        private readonly apiKey: string,
    ) {}

    public getCurrentMint = (sessionId: number): Promise<Session> =>
        axios
            .get<Session>(`${this.url}/session/${sessionId}`, {
                headers: {
                    'x-api-key': this.apiKey,
                },
            })
            .then((res) => res.data);

    public setCurrentMint = (sessionId: number, mint: string) =>
        axios
            .post<string>(
                this.url + `/session/${sessionId}`,
                { mint },
                {
                    headers: {
                        'x-api-key': this.apiKey,
                    },
                },
            )
            .then((res) => res.data);

    public parseToken = (mint: string): Promise<ParsedTokenMetadata> =>
        axios
            .get<ParsedTokenMetadata>(this.url + `/token/${mint}/fetch`, {
                headers: {
                    'x-api-key': this.apiKey,
                },
            })
            .then((res) => res.data);

    public fetchPoolKeys = (mint: string): Promise<ApiPoolInfoV4> =>
        axios
            .get(this.url + `/token/${mint}/pool-keys`, {
                headers: {
                    'x-api-key': this.apiKey,
                },
            })
            .then((res) => res.data);

    public setPoolKeys = (mint: string, poolKeys: ApiPoolInfoV4) =>
        axios
            .post<ApiPoolInfoV4>(this.url + `/token/${mint}/pool-keys`, poolKeys, {
                headers: {
                    'x-api-key': this.apiKey,
                },
            })
            .then((res) => res.data);
}
